/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Show_ColumnsInputs */

const en_show_columns = /** @type {(inputs: Show_ColumnsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show columns`)
};

const nl_show_columns = /** @type {(inputs: Show_ColumnsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toon kolommen`)
};

/**
* | output |
* | --- |
* | "Show columns" |
*
* @param {Show_ColumnsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const show_columns = /** @type {((inputs?: Show_ColumnsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Show_ColumnsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_show_columns(inputs)
	return en_show_columns(inputs)
});